import { isBrandCategoryMetas, isCategoryMetas, isCombinationMetas } from '@/app/(plp)/_utils/type-guards'
import { PLPBasicMetasProps, PLPPages } from '@/app/(plp)/types'

export const createBreadCrumbItems = (page: PLPPages, basicMetas: PLPBasicMetasProps | undefined) => {
    switch (page) {
        case PLPPages.BrandCategoriesCombination: {
            const metas = isCombinationMetas(page, basicMetas) ? basicMetas : undefined

            const breadcrumb = [...(metas?.breadcrumb || [])]

            breadcrumb.push({
                nameFa: metas?.seoH1 || '',
            })

            return breadcrumb
        }

        case PLPPages.Combination: {
            const metas = isBrandCategoryMetas(page, basicMetas) ? basicMetas : undefined

            const category = metas?.category
            const brand = metas?.brand

            const breadcrumb = [...(category?.breadcrumb || [])]

            breadcrumb.push({
                nameFa: `${category?.breadcrumb?.at(-1)?.nameFa} ${brand?.nameFa}`,
                slug: `${category?.breadcrumb?.at(-1)?.slug}`,
            })

            return breadcrumb
        }

        case PLPPages.Categories:
            return isCategoryMetas(page, basicMetas) ? basicMetas.breadcrumb : null

        default:
            return null
    }
}
